import React from 'react';
import DynamicMainMenuList from './DynamicMainMenuList';
import { useLocale } from '../../../contexts/LocaleProvider';
import './Header.css';

// Legacy type: MainMenuList still references MenuTitle
export interface MenuTitle {
    title: string;
}

const buttonStyling_us = {
    justifyContent: 'center',
    padding: 0,
    paddingBottom: '0.5rem',
    textDecoration: 'none',
    fontSize: '1.125rem',
    fontWeight: '500',
    lineHeight: '1.69rem',
    color: '#191A1B',
    fontFamily: 'Poppins',
};
const buttonStyling_de = {
    justifyContent: 'center',
    padding: 0,
    textDecoration: 'none',
    fontSize: '0.95rem',
    fontWeight: '500',
    lineHeight: '1.69rem',
    color: '#191A1B',
    fontFamily: 'Poppins',
};

export default function HeaderMenuList() {
    const { locale } = useLocale();
    const buttonStyling = locale === 'de' ? buttonStyling_de : buttonStyling_us;
    return (
        <nav className="frame44">
            <ul>
                <DynamicMainMenuList buttonStyling={buttonStyling} isNavSubMenu={false} />
            </ul>
        </nav>
    );
}
